package com.gsb.vyapar.bhagya.presentation.common.icon

import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun BottomBarIcon(res: DrawableResource) {
    Icon(
        painter = painterResource(res),
        contentDescription = "BottomBarIcon",
        modifier = Modifier
            .width(24.dp)
            .height(24.dp)
    )
}